export const LOCALES = [
    { code: "en", name: "English", native: "English", rtl: false },
    { code: "ar", name: "Arabic", native: "العربية", rtl: true },
    { code: "fr", name: "French", native: "Français", rtl: false },
    { code: "de", name: "German", native: "Deutsch", rtl: false },
    { code: "zh", name: "Chinese", native: "中文", rtl: false },
    { code: "ja", name: "Japanese", native: "日本語", rtl: false },
    { code: "ru", name: "Russian", native: "Русский", rtl: false },
    { code: "id", name: "Indonesian", native: "Bahasa Indonesia", rtl: false },
    { code: "ms", name: "Malay", native: "Bahasa Melayu", rtl: false },
    { code: "sw", name: "Kiswahili", native: "Kiswahili", rtl: false },
    { code: "ta", name: "Tamil", native: "தமிழ்", rtl: false },
];

export const DEFAULT_LOCALE = "en";
export const SUPPORTED_CODES = LOCALES.map((l) => l.code);
export const NON_DEFAULT_CODES = SUPPORTED_CODES.filter((c) => c !== DEFAULT_LOCALE);

export function getLocaleMeta(code) {
    return LOCALES.find((l) => l.code === code) || LOCALES[0];
}

/**
 * Extract locale from a pathname like "/ar/about" -> { locale: "ar", rest: "/about" }.
 * If the first segment is not a supported non-default locale, returns { locale: "en", rest: pathname }.
 */
export function parseLocalePath(pathname) {
    const parts = pathname.split("/").filter(Boolean);
    if (parts.length > 0 && NON_DEFAULT_CODES.includes(parts[0])) {
        return { locale: parts[0], rest: "/" + parts.slice(1).join("/") };
    }
    return { locale: DEFAULT_LOCALE, rest: pathname };
}

/**
 * Build a locale-aware URL. English is stored without a prefix.
 */
export function buildLocaleUrl(path, locale) {
    if (!path) path = "/";
    if (locale === DEFAULT_LOCALE) return path;
    const clean = path.startsWith("/") ? path : `/${path}`;
    if (clean === "/") return `/${locale}`;
    return `/${locale}${clean}`;
}
